import React, { useState, useEffect } from 'react';
import { Container, Card, Spinner, Alert } from 'react-bootstrap';
import { usePageTitle } from '../context/PageTitleContext';
import { renderTermsMarkdown } from './Terms';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';

/**
 * Generic static content page (About / Contact / Privacy) backed by the
 * content_pages table (#66). Fetches GET /content/{slug} and renders the
 * markdown body. Single source of truth shared with iOS — editing a page
 * happens in one place (the DB), not per surface.
 *
 * Terms keeps its own component (Terms.js) because /terms also carries the
 * acceptance version; this renders the same way.
 */
function ContentPage({ slug, title }) {
  const { setPageTitle } = usePageTitle();
  const [page, setPage] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    if (title) setPageTitle(title);
  }, [title, setPageTitle]);

  useEffect(() => {
    let active = true;
    const fetchPage = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/content/${slug}`);
        if (!response.ok) throw new Error('Failed to load');
        const data = await response.json();
        if (active) setPage(data);
      } catch (err) {
        if (active) setError('Failed to load this page. Please try again later.');
      }
    };
    fetchPage();
    return () => { active = false; };
  }, [slug]);

  if (error) {
    return (
      <Container className="mt-5">
        <Alert variant="danger">{error}</Alert>
      </Container>
    );
  }

  if (!page) {
    return (
      <Container className="mt-5 text-center">
        <Spinner animation="border" />
      </Container>
    );
  }

  return (
    <Container className="mt-4 mb-5">
      <div className="row justify-content-center">
        <div className="col-lg-8">
          <Card>
            <Card.Body className="p-4">
              {renderTermsMarkdown(page.body)}
            </Card.Body>
          </Card>
        </div>
      </div>
    </Container>
  );
}

export default ContentPage;
